<template>
  <div id="reset-password">

    <div class="content">
      <div id="container">
        <p id="reset-title">{{ $t('resetPassword') }}</p>

        <div class="reset-content">
          <div class="form-group">
            <label for="password">{{ $t('setPassword') }}</label>
            <input 
              type="password" 
              name="password" 
              id="password" 
              v-if="!isShowPwd"
              :placeholder="$t('setPassword')"
              v-model.trim="password"
              v-validate="'required|min:6|max:20'"
              :class="{'input pwd': true, 'danger-border': PwdValidateError}"
              @keyup.enter="resetPwd"
              @blur="showError.password = true"
              autocomplete="new-password">
            <input 
              v-if="isShowPwd"
              type="text" 
              name="password"
              id="password"
              :placeholder="$t('setPassword')"
              v-model.trim="password"
              v-validate="'required|min:6|max:20'"
              :class="{'input pwd': true, 'danger-border': PwdValidateError}"
              @keyup.enter="resetPwd"
              @blur="showError.password = true"
              autocomplete="new-password">
            <span class="show-pwd" @click="isShowPwd = !isShowPwd">
              <img src="/static/img/dashboard/ic_eye.svg" v-show="isShowPwd" alt="" />
              <img src="/static/img/dashboard/ic_eye_off.svg" v-show="!isShowPwd" alt="" />
            </span>
            <p class="error-info">
              <span v-show="PwdValidateError">{{ errors.first('password') }}</span>
            </p>
          </div>

          <div class="form-group confirm-password-box">
            <label for="confirmPwd">{{ $t('confirmPwd') }}</label>
            <input 
              type="password" 
              name="confirmPwd" 
              id="confirmPwd" 
              v-if="!isShowConfirmPWd"
              :placeholder="$t('confirmPwd')"
              v-model.trim="confirmPwd"
              v-validate="'required|confirmed:password|min:6|max:20'"
              :class="{'input pwd': true, 'danger-border': confirmPwdValidateError}"
              @keyup.enter="resetPwd"
              @blur="showError.confirmPwd = true">

            <input 
              type="text" 
              name="confirmPwd" 
              id="confirmPwd" 
              v-if="isShowConfirmPWd"
              :placeholder="$t('confirmPwd')"
              v-model.trim="confirmPwd"
              v-validate="'required|confirmed:password|min:6|max:20'"
              :class="{'input pwd': true, 'danger-border': confirmPwdValidateError}"
              @keyup.enter="resetPwd"
              @blur="confirmPwdBlur = true">
            <span class="show-pwd" @click="isShowConfirmPWd=!isShowConfirmPWd">
              <img src="/static/img/dashboard/ic_eye.svg" v-show="isShowConfirmPWd" alt="" />
              <img src="/static/img/dashboard/ic_eye_off.svg" v-show="!isShowConfirmPWd" alt="" />
            </span>
            <p class="error-info">
              <span v-show="confirmPwdValidateError">{{ errors.first('confirm') }}</span>
            </p>
          </div>

          <p>{{ errorMsg }}</p>

          <button type="button" class="form-submit line-button" @click="resetPwd" v-if="!loading">{{ $t('submit') }}</button>
          <spinner class="spinner-component" :show="loading"></spinner>
        </div>
      </div>
    </div>

    <reset-pwd-success-modal :show="resetPwdSuccess" :loginData="loginData"></reset-pwd-success-modal>
  </div>
</template>

<script>
  import Spinner from '../../components/Spinner.vue'
  import ResetPwdSuccessModal from '../../components/resetPwdSuccessNotice/SuccessNotice.vue'
  import locales from './lang'

  export default{
    name: 'reset-pwd',
    components: {
      Spinner, ResetPwdSuccessModal
    },
    data: function () {
      return {
        resetToken: '',
        email: '',
        phone: '',
        isShowPwd: false,
        password: '',
        loading: false,
        confirmPwd: '',
        isShowConfirmPWd: false,
        networkError: this.$t('networkError'),
        showError: {
          'password': false,
          'confirmPwd': false
        },
        showSuccess: {
          'password': false,
          'confirmPwd': false
        },
        resetPwdSuccess: false,
        errorMsg: ''
      }
    },
    computed: {
      PwdValidateError() {
        return this.showError.password && this.errors.has('password')
      },
      confirmPwdValidateError() {
        return this.showError.confirmPwd && this.errors.has('confirm')
      },
      dialCode() {
        return this.$store.state.dialCode
      },
      resetType() {
        if (this.email) {
          return 'email'
        } else {
          return 'phone'
        }
      },
      loginData() {
        if (this.email) {
          return {
            email: this.email,
            password: this.password
          }
        } else {
          return {
            calling_code: this.dialCode,
            phone_num: this.phone,
            password: this.password
          }
        }
      }
    },
    locales,
    watch: {
      password() {
        this.showError.password = false
        this.showSuccess.password = true
      },
      confirmPwd() {
        this.showError.confirmPwd = false
        this.showSuccess.confirmPwd = true
      }
    },
    created: function () {
      this.email = this.$route.query.email
      this.phone = this.$route.query.phone
      this.resetToken = this.$route.query.reset_token
      if (window.localStorage.getItem('token') !== null) {
        this.$router.replace('/dashboard')
      }
    },
    methods: {
      resetPwd() {
        this.$validator.validateAll().then(success => {
          if (!success) {
            this.showError.password = true
            this.showError.confirmPwd = true
            return
          }
          let resetData = {
            type: this.resetType,
            password: this.password,
            token: this.resetToken
          }
          if (this.email) {
            resetData.email = this.email
          } else {
            resetData.phone_num = this.phone
            resetData.calling_code = this.dialCode
          }
          this.loading = true
          this.$http.patch('api/password/reset/reset-password-by-token', resetData).then((response) => {
            this.loading = false
            switch (response.data.code) {
              case 0: {
                this.resetPwdSuccess = true
                break
              }
              default: {
                this.errorMsg = response.data.message
              }
            }
          }, () => {
            this.loading = false
          })
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/formstyle";
  div.form-group {
    input {
      margin-top: .08rem;
      height: .54rem;
      line-height: .54rem;
      border: 1px solid #E0D7E3;
      border-radius: 42px;
      padding: 0 24px;
      font-size: 16px;
      &::placeholder {
        color: #ccc;
      }
      &.pwd {
        padding-right: 50px;
      }
    }
    .show-pwd {
      right: 24px;
      bottom: 37px;
    }
  }
  .form-submit {
    margin: .16rem 0 0;
    height: 54px;
    line-height: 54px;
    font-size: 18px;
    font-weight: 600;
    background-image: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%);
    border-radius: 42px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 4px;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
      border-radius: 42px;
      filter: blur(4px);
      -webkit-filter: blur(4px);
      -moz-filter: blur(4px);
      -ms-filter: blur(4px);
      -o-filter: blur(4px);
      z-index: -1;
    }
  }

  #reset-password {
    width: 100%;
    background: url('/static/img/loginRegister/bg.png') no-repeat center bottom;
    min-height: 100vh;
    padding-top: 1.6rem;
  }

  #container {
    max-width: 4rem;
    width: 100%;
    margin: 0 auto;
  }

  #reset-title {
    text-align: center;
    font-size: 24px;
    line-height: 24px;
    font-weight: 600;
    color: #333333;
    letter-spacing: 0.82px;
    margin-bottom: 40px;
  }

  .reset-content {
    max-width: 4rem;
    width: 100%;
    margin: 0 auto;
  }

  .oauth-login {
    max-width: 4rem;
  }

  #new-to-plex {
    max-width: 4rem;
    width: 100%;
    margin: 0 auto;
    color: #999;
    letter-spacing: 0;
    line-height: .16rem;
    text-align: center;
    a {
      color: #416CF8;
    }
  }

  @media (max-width: 991px) {
    #reset-password {
      padding-top: 0.9rem;
    }
  }

  @media (max-width: 767px) {
    #reset-password {
      padding: .24rem .24rem 0;
      background-image: url('/static/img/loginRegister/bg_h5.png');
      background-size: 100%;
    }
    div.form-group {
      input {
        height: 0.49rem;
        line-height: .49rem;
        font-size: 14px;
        padding: 0 16px;
      }
      .show-pwd {
        right: 16px;
        bottom: 25px;
      }
    }
    .error-info {
      margin-top: 0.02rem;
    }
    .form-submit {
      margin-top: .24rem;
      height: 49px;
      line-height: 49px;
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?0efebae2